import Box from 'carbon-react/lib/components/box';
import Button from 'carbon-react/lib/components/button/__next__';
import { useNavigate } from 'react-router';
import { Sequence } from './Sequence';
import { Steps } from './steps';

const LastStep = () => {
  const navigate = useNavigate();
  return (
    <div className="provision">
      <div className="card">
        <Box pb={4}>
          <Sequence step={Steps.LAST_STEP} />
        </Box>
        <Button fullWidth onClick={() => navigate('/')}>
          Go to Home
        </Button>
      </div>
    </div>
  );
};

export default LastStep;
